import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';
import { MARQUEE_ITEMS } from '../../data/seedData';

const marqueeAnim = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(-50%); }
`;

export default function Marquee() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];

  return (
    <Box
      borderTop="1px solid rgba(0,195,255,0.08)"
      borderBottom="1px solid rgba(0,195,255,0.08)"
      py={3.5}
      bg="#0f0f14"
      overflow="hidden"
    >
      <Flex
        width="max-content"
        animation={`${marqueeAnim} 28s linear infinite`}
      >
        {items.map((item, i) => (
          <Box
            key={i}
            px={9}
            color="#7878a0"
            fontSize="0.82rem"
            fontWeight={500}
            whiteSpace="nowrap"
            display="flex"
            alignItems="center"
            gap={2.5}
          >
            <Text as="span">{item.split(' ')[0]}</Text>
            <Text as="span" color="#00c3ff">{item.split(' ').slice(1).join(' ')}</Text>
          </Box>
        ))}
      </Flex>
    </Box>
  );
}
